/**
 * Which nav tree the sidebar shows: org-wide (Events/Chat/Organization group) or the current
 * event's own nav (Home/Details/Notes/Chat/Source group/Manage group).
 */
export type SidebarMode = "org" | "event";

/**
 * Dashboard Source tabs.
 */
export enum SourceTab {
  SEARCH = "search",
  PROPOSALS = "proposals",
  MESSAGES = "messages",
  CONTRACTS = "contracts",
  PAYMENTS = "payments",
}

/**
 * Dashboard Manage tabs.
 */
export enum ManageTab {
  REGISTRATION = "registration",
}

/**
 * Dashboard Registration tabs (children of ManageTab.REGISTRATION).
 */
export enum RegistrationTab {
  OVERVIEW = "overview",
  LANDING_PAGES = "landing-pages",
  ACTIVITIES = "activities",
  SCHEDULE = "schedule",
  FORMS = "forms",
}

/**
 * Organization subsections.
 */
export enum OrganizationSubsection {
  EVENTS = "events",
  SETTINGS = "settings",
  USERS = "users",
  APPROVALS = "approvals",
  REPORTING = "reporting",
}

/**
 * Organization Settings tabs.
 */
export enum OrganizationTab {
  PROFILE = "profile",
  OFFICE_LOCATION = "office-location",
  PREFERRED_VENUES = "preferred-venues",
  BLACKLISTED_VENUES = "blacklisted-venues",
  POLICIES = "policies",
  CONTRACTS = "contracts",
  INTEGRATIONS = "integrations",
}

/**
 * Organization Users and Groups tabs.
 */
export enum UsersTab {
  USERS = "users",
  GROUPS = "groups",
}

/**
 * Organization Reporting tabs.
 */
export enum ReportingTab {
  OVERVIEW = "overview",
  TOOL_USAGE = "tool-usage",
  SPEND = "spend",
  SAVINGS = "savings",
  SUSTAINABILITY = "sustainability",
  USER_SATISFACTION = "user-satisfaction",
}
